import { useRef } from 'react'
import { useNavigate } from 'react-router-dom'

const TOUCH_TAP_SLOP = 12

const GlowAlbumCard = ({ id, image, title, band, date, length, genre, detailPath = 'album' }) => {
	const cardRef = useRef(null)
	const coverRef = useRef(null)
	const touchStartRef = useRef(null)
	const touchMovedRef = useRef(false)
	const navigate = useNavigate()

	const updatePosition = (clientX, clientY) => {
		const card = cardRef.current
		const cover = coverRef.current

		if (!card || !cover) return

		const rect = card.getBoundingClientRect()
		const x = clientX - rect.left
		const y = clientY - rect.top

		const centerX = rect.width / 2
		const centerY = rect.height / 2

		const percentX = (x / rect.width) * 100
		const percentY = (y / rect.height) * 100

		const rotateX = ((y - centerY) / centerY) * -10
		const rotateY = ((x - centerX) / centerX) * 10

		card.style.setProperty('--mouse-x', `${percentX}%`)
		card.style.setProperty('--mouse-y', `${percentY}%`)

		cover.style.transform = `
      rotateX(${rotateX}deg)
      rotateY(${rotateY}deg)
      scale(1.05)
    `

		const angle = Math.atan2(y - centerY, x - centerX) * (180 / Math.PI)
		card.style.setProperty('--angle', `${angle}deg`)
	}

	const resetCard = () => {
		const card = cardRef.current
		const cover = coverRef.current

		if (!card || !cover) return

		cover.style.transform = 'rotateX(0) rotateY(0) scale(1)'
		card.style.setProperty('--mouse-x', '50%')
		card.style.setProperty('--mouse-y', '50%')

		card.classList.remove('active')
	}

	const handleMouseMove = (e) => {
		updatePosition(e.clientX, e.clientY)
	}

	const handleClick = (e) => {
		if (e.pointerType === 'touch') return
		navigate(`/${detailPath}/${id}`)
	}

	const handleTouchStart = (e) => {
		const touch = e.touches[0]
		touchStartRef.current = { x: touch.clientX, y: touch.clientY }
		touchMovedRef.current = false
		updatePosition(touch.clientX, touch.clientY)
		cardRef.current.classList.add('active')
	}

	const handleTouchMove = (e) => {
		if (!touchStartRef.current || touchMovedRef.current) return

		const touch = e.touches[0]
		const deltaX = touch.clientX - touchStartRef.current.x
		const deltaY = touch.clientY - touchStartRef.current.y
		if (Math.hypot(deltaX, deltaY) > TOUCH_TAP_SLOP) {
			touchMovedRef.current = true
			resetCard()
			return
		}

		updatePosition(touch.clientX, touch.clientY)
	}

	const handleTouchEnd = (e) => {
		resetCard()

		const touch = e.changedTouches[0]
		const start = touchStartRef.current
		const isTap =
			start &&
			!touchMovedRef.current &&
			Math.hypot(touch.clientX - start.x, touch.clientY - start.y) <= TOUCH_TAP_SLOP
		const rect = cardRef.current.getBoundingClientRect()
		const stillInside =
			touch.clientX >= rect.left &&
			touch.clientX <= rect.right &&
			touch.clientY >= rect.top &&
			touch.clientY <= rect.bottom

		touchStartRef.current = null
		touchMovedRef.current = false

		if (isTap && stillInside) {
			navigate(`/${detailPath}/${id}`)
		}
	}

	const handleTouchCancel = () => {
		resetCard()
		touchStartRef.current = null
		touchMovedRef.current = false
	}

	return (
		<article
			className='collection-card album-card'
			ref={cardRef}
			onMouseMove={handleMouseMove}
			onMouseLeave={resetCard}
			onTouchStart={handleTouchStart}
			onTouchMove={handleTouchMove}
			onTouchEnd={handleTouchEnd}
			onTouchCancel={handleTouchCancel}
			onClick={handleClick}>
			{/* glow background */}
			<div className='glow-layer'></div>
			<div className='collection-img-container album-cover' ref={coverRef}>
				<img src={image} className='collection-img' alt='' />

				{/* glow effects */}
				<div className='edge-glow'></div>
				<div className='shine-effect'></div>
				<div className='border-glow'></div>

				<p className='collection-date'>{date}</p>

				<div className='album-overlay'>
					<div className='album-info'>
						<div className='album-title'>{title}</div>
						<div className='album-artist'>{band}</div>
					</div>
				</div>
			</div>
			<div className='collection-info'>
				<div className='collection-title'>
					<h4>{title}</h4>
				</div>

				<div className='collection-footer'>
					<div>
						<p>{band}</p>
						<p>{genre}</p>
						<p className='collection-length'>{length}</p>
					</div>
				</div>
			</div>
		</article>
	)
}

export default GlowAlbumCard
